import React, { useId } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import Switch from "../Switch/Switch"
import { EMAIL_GROUPS, orderGroupKeys } from "./emailGroups"

const ALWAYS_ARRIVE_NOTE = "Password resets, sign-in codes and invites always arrive. The bell in the CRM still shows everything."

const EmailSettingsFields = ({ value, onChange, disabled = false }) => {
  const baseId = useId()
  const muteAllId = `${baseId}-mute-all`
  const muteAll = value?.muteAll === true
  const mutedGroups = orderGroupKeys(value?.mutedGroups)
  const groupsLocked = disabled || muteAll

  const handleMuteAll = (next) => {
    onChange({ muteAll: next, mutedGroups })
  }

  const handleGroup = (key, checked) => {
    const next = checked ? [...mutedGroups, key] : mutedGroups.filter((item) => item !== key)
    onChange({ muteAll, mutedGroups: orderGroupKeys(next) })
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <Switch
          id={muteAllId}
          checked={muteAll}
          onChange={handleMuteAll}
          disabled={disabled}
        />
        <label
          htmlFor={muteAllId}
          className={classnames('text-sm font-medium cursor-pointer select-none', {
            'text-text-secondary cursor-not-allowed': disabled,
            'text-text-primary': !disabled,
          })}
        >
          Mute all notification emails
        </label>
      </div>
      <p className="text-sm text-text-secondary">Or mute only these groups:</p>
      <div className="flex flex-col gap-3">
        {EMAIL_GROUPS.map((group) => {
          const inputId = `${baseId}-${group.key}`
          const descriptionId = `${inputId}-description`
          return (
            <div key={group.key} className="flex items-start gap-3">
              <input
                type="checkbox"
                id={inputId}
                aria-describedby={descriptionId}
                checked={mutedGroups.includes(group.key)}
                onChange={(event) => handleGroup(group.key, event.target.checked)}
                disabled={groupsLocked}
                className="w-5 h-5 shrink-0 cursor-pointer disabled:cursor-not-allowed"
              />
              <div className="flex flex-col">
                <label
                  htmlFor={inputId}
                  className={classnames('text-sm font-medium select-none', {
                    'cursor-pointer text-text-primary': !groupsLocked,
                    'cursor-not-allowed text-text-secondary': groupsLocked,
                  })}
                >
                  {group.label}
                </label>
                <span id={descriptionId} className="text-sm text-text-secondary">{group.description}</span>
              </div>
            </div>
          )
        })}
      </div>
      <p className="text-sm text-text-secondary">{ALWAYS_ARRIVE_NOTE}</p>
    </div>
  )
}

EmailSettingsFields.propTypes = {
  value: PropTypes.shape({
    muteAll: PropTypes.bool,
    mutedGroups: PropTypes.arrayOf(PropTypes.string),
  }),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default EmailSettingsFields
